// extracted by mini-css-extract-plugin
export default {"modalContainer":"payment-method_modalContainer__kH5JW","modalSubTitle":"payment-method_modalSubTitle__jK6y9"};